export type ButtonVariant =
  | 'primary'
  | 'secondary'
  | 'ghost'
  | 'soft'
  | 'danger'
  | 'success'
  | 'link';

export type ButtonSize = 'xs' | 'sm' | 'md' | 'lg';

export const BUTTON_VARIANT: Record<ButtonVariant, string> = {
  primary:
    'btn-glow text-white font-semibold tracking-wide bg-brand-400 hover:bg-brand-500 active:bg-brand-300 disabled:bg-brand-400',
  secondary:
    'btn-soft-glow bg-surface text-ink border border-line hover:bg-surface-muted hover:border-line-strong active:bg-surface-muted',
  ghost:
    'btn-soft-glow bg-transparent text-ink-muted hover:bg-surface-muted hover:text-ink active:bg-surface-raised',
  soft:
    'btn-soft-glow bg-brand-500/10 text-brand-700 border border-brand-500/20 hover:bg-brand-500/[0.16] hover:border-brand-500/35',
  danger:
    'btn-soft-glow text-white bg-danger hover:bg-danger/90 active:bg-danger/80',
  success:
    'btn-soft-glow text-white bg-success hover:bg-success/90 active:bg-success/80',
  link:
    'bg-transparent text-brand-700 hover:text-brand-600 hover:underline underline-offset-4 px-0',
};

export const BUTTON_SIZE: Record<ButtonSize, string> = {
  xs: 'h-7 px-2.5 text-xs gap-1 rounded-md',
  sm: 'h-8 px-3 text-xs gap-1.5 rounded-md',
  md: 'h-9 px-4 text-sm gap-2 rounded-lg',
  lg: 'h-10 px-5 text-sm gap-2 rounded-lg font-semibold',
};

export const BUTTON_BASE =
  'inline-flex items-center justify-center font-medium select-none transition-all duration-200';
